export default __webpack_public_path__ + "static/kb_3_15-1663cdc04c2ee758c91a548bd2b66656.jpg";